import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

const manageStaffAPI = createApi({
    reducerPath: 'manageStaffAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({


        getAllStaff: builder.query({
            query: ({ plJobTypeKey, pbIncludeInactive }) => ({
                url: `/AdminManageStaff/GetAllStaff?plJobTypeKey=${plJobTypeKey}&pbIncludeInactive=${pbIncludeInactive}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllJobTypes: builder.mutation({
            query: (data) => ({
                url: `/AdminManageStaff/GetJobTypes`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addStaff: builder.mutation({
            query: (data) => ({
                url: `/AdminManageStaff/CreateStaff`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


    }),
});

export const {
    useLazyGetAllStaffQuery,
    useGetAllJobTypesMutation,
    useAddStaffMutation
} = manageStaffAPI;

export default manageStaffAPI;